import React, { useEffect, useState } from 'react'
import { Select, SelectItem } from '@/components/Select'
import { api } from '@/api'
import { ICountry } from '@/interfaces/Country'
import style from './styles/select.module.scss'
import Spinner from '@/components/Spinner/Spinner'
import classnames from 'classnames'

const CountrySelect = ({
  label = 'Страна:',
  theme = 'gray',
  valueType = 'id',
  ...props
}): React.ReactElement => {
  const [data, setData] = useState<ICountry[]>([])

  useEffect(() => {
    api.getCountries()
      .then((data) => {
        setData(data.results)
      })
      .catch(err => {
        console.log(err)
      })
  }, [])

  if (data.length === 0) {
    return (
      <div className={classnames(style.placeholder, props.className)}>
        <div className={classnames(style.placeholder__label)}>{label}</div>
        <div className={style.placeholder__block}>
          <Spinner color='red' />
        </div>
      </div>
    )
  }

  return (
    <Select theme={theme} placeholder='Выбери' label={label} {...props}>
      {data.map((el) => {
        return (
          <SelectItem value={el[valueType]} key={el.id}>
            {el.title}
          </SelectItem>
        )
      })}
    </Select>
  )
}

export default CountrySelect
